import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformType } from "@root/config";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";

interface ModalData {
  thirdpartyType: PlatformType;
}

@Component({
  selector: "host-set-pricing-ratio",
  templateUrl: "./set-pricing-ratio.component.html",
  styleUrls: ["./set-pricing-ratio.component.scss"],
})
export class V4SetPricingRatioComponent implements OnInit {
  @Output() onBack = new EventEmitter();
  @Output() onNext = new EventEmitter();
  modalRef = inject(NzModalRef, { optional: true });
  modalData: ModalData = inject(NZ_MODAL_DATA, { optional: true });
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-start md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;
  thirdpartyType: PlatformType = this.modalData?.thirdpartyType;
  listOfChannel = [];
  loading = false;
  pageLoading = false;
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    console.log("modalref: ", this.modalRef);

    /**
     * 不是使用弹窗打开的，则需要通过路由传递参数
     */
    if (!this.modalRef) {
      this.thirdpartyType = +this.route.snapshot.queryParams.thirdparty_type;
    }

    this.initChannelList();
  }

  private initChannelList() {
    this.pageLoading = true;
    this.http.get("/api/setting/channel_price_ratio").subscribe((rst: any) => {
      this.pageLoading = false;
      this.listOfChannel = rst?.data?.list ?? [];
    });
  }

  private requestSave() {
    this.loading = true;
    const params = { list: this.listOfChannel };
    this.http.post("/api/setting/set_channel_price_ratio", params).subscribe((rst: any) => {
      this.loading = false;
      if (rst?.error_code === 0) {
        this.navigate();
        // this.modalRef.destroy("success");
      }
    });
  }

  private navigate() {
    if (this.modalRef) {
      this.modalRef.destroy("success");
    } else {
      this.router.navigate(["../connect-success"], { relativeTo: this.route });
    }
  }

  onSave() {
    this.requestSave();
  }
}
